import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { deepMerge } from '../../utils';

ThemeContext.Extend = function (_ref) {
  var children = _ref.children,
      value = _ref.value;
  return React.createElement(ThemeContext.Consumer, null, function (theme) {
    return React.createElement(ThemeContext.Provider, {
      value: deepMerge(theme, value)
    }, children);
  });
};

ThemeContext.Extend.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({}).isRequired
};
export { ThemeContext };


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/es6/contexts/ThemeContext/ThemeContext.js
// module id = 290
// module chunks = 0